// extracted by mini-css-extract-plugin
export default {"text":"nFXgOhaAlex3degQlcnn","pulse":"hyPhBXESi6DQOsO5WLHY"};